import Swiper, { Navigation, Pagination } from 'swiper';
Swiper.use([Navigation, Pagination]);
export class ThumbSlider {
    constructor(target, order) {
        this.myTapEvent = window.ontouchstart === null ? 'touchstart' : 'click';
        this.target = target;
        this.order = order;
        this.exec();
    }
    exec() {
        const addClassName = `${ThumbSlider.targetClassName}--order_${this.order}`;
        this.target.classList.add(addClassName);
        const eachTargetSelector = `.${ThumbSlider.targetClassName}.${addClassName}`;
        const mySlider = new Swiper(eachTargetSelector, {
            init: false,
            loop: false,
            speed: 800,
            slidesPerView: "auto",
            navigation: {
                nextEl: '.js-thumb-slider__next',
                prevEl: '.js-thumb-slider__prev',
            },
            pagination: {
                el: '.js-thumb-slider__pagination',
                type: 'custom',
                renderCustom: function (swiper, current, total) {
                    const slides = swiper.slides;
                    let html = '';
                    for (let i = 0; i < total; i++) {
                        if (current == i + 1) {
                            html = html + `<div class="p-thumb-slider__pagination-item js-thumb-slider__pagination-item current" data-slideto="${i}">${slides[i].innerHTML}</div>`;
                        }
                        else {
                            html = html + `<div class="p-thumb-slider__pagination-item js-thumb-slider__pagination-item" data-slideto="${i}">${slides[i].innerHTML}</div>`;
                        }
                    }
                    return html;
                },
            },
        });
        mySlider.on('init', () => {
            const thumbItems = mySlider.el.getElementsByClassName('js-thumb-slider__pagination-item');
            if (thumbItems.length) {
                for (let i = 0; i < thumbItems.length; i++) {
                    thumbItems[i].addEventListener(this.myTapEvent, ((event) => {
                        if (event.currentTarget && event.currentTarget instanceof HTMLElement) {
                            let index = event.currentTarget.getAttribute('data-slideto');
                            if (index) {
                                index = parseFloat(index);
                                mySlider.slideTo(index, 800, true);
                            }
                        }
                    }), false);
                }
            }
        });
        mySlider.on('slideChange', () => {
            const thumbItems = mySlider.el.getElementsByClassName('js-thumb-slider__pagination-item');
            if (thumbItems.length) {
                for (let i = 0; i < thumbItems.length; i++) {
                    thumbItems[i].addEventListener(this.myTapEvent, ((event) => {
                        if (event.currentTarget && event.currentTarget instanceof HTMLElement) {
                            let index = event.currentTarget.getAttribute('data-slideto');
                            if (index) {
                                index = parseFloat(index);
                                mySlider.slideTo(index, 800, true);
                            }
                        }
                    }), false);
                }
            }
        });
        mySlider.init();
    }
    static init() {
        const target = document.getElementsByClassName(ThumbSlider.targetClassName);
        if (target.length) {
            for (let i = 0; i < target.length; i++) {
                if (!(target[i] instanceof HTMLElement)) {
                    continue;
                }
                const thisTarget = target[i];
                const thisTargetOrder = String(i);
                new ThumbSlider(thisTarget, thisTargetOrder);
            }
        }
    }
}
ThumbSlider.targetClassName = 'js-thumb-slider';
